import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import MainAppBar from "../../components/MainAppBar";
import styles from "./StatisticsStyles";
import StatisticsView from "./StatisticsView";
import ApiUser from "../../../API/ApiUser";

class StatisticsComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showError: false,
      errorMessage: "",
      showSuccess: false,
      successMessage: "",
      analytics: [],
      isLoading: true,
    };
  }

  componentDidMount() {
    document.title = "Statistiques | Landing Zone";
    this.fetchAnalytics();
  }

  fetchAnalytics = async () => {
    try {
      const response = await ApiUser.getAnalytics();
      console.log("response ", response);
      if (response.status === 200) {
        this.setState({
          analytics: response.data,
          isLoading: false,
        });
      } else {
        this.setState({
          showError: true,
          errorMessage: "Erreur lors de la récupération des statistiques",
          isLoading: false,
        });
      }
    } catch (error) {
      this.setState({
        showError: true,
        errorMessage: "Une erreur est survenue",
        isLoading: false,
      });
    }
  };

  render() {
    const { classes } = this.props;
    const { analytics, isLoading } = this.state;

    return (
      <>
        <MainAppBar />
        <StatisticsView
          {...this.props}
          state={this.state}
          classes={classes}
          analytics={analytics}
          isLoading={isLoading}
        />
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(StatisticsComponent);
